module.exports = __webpack_public_path__ + "img/doctor_step3.926e9702.png";